const REGEX = /([^-\s#.'"]+)((?:-[A-Z]?\d+)*-[A-Z]?)(\d+)/;		// Matches "#(name)(-0)" or '.(name)(-A0-A0)' for example

const getColumns = function(form, selector)
{

	let columns = [];

	document.querySelectorAll(`${selector} *`).forEach(node =>
	{
		let column = getColumn(form, node);
		if (column)
		{
			columns.push(column);
		}
	});

	if (columns.length == 0)
		throw new Error(`No indexed columns in ${selector}`);

	return columns;

};

const getColumn = function(form, node)
{

	let id = getId(node);

	if (!id)
		return;

	let parts = id.match(REGEX);

	if (!parts || parts.length < 4)		// [ 'field-0', 'field', '-', '0' ]; 
		return;

	let field = form.getFieldByName(parts[0]);

	// <datalist id="packagings-0"> (e similares) segue o índice da linha mas não é coluna em fields — só apoia o <input list="…">.
	if (!field && node.tagName === 'DATALIST')
		return;

	if (!field)
		throw new Error(
			`Campo «${parts[0]}» aparece no HTML da tabela, mas não está declarado em fields do formulário. ` +
			'Inclua a entrada em js/forms/… ou remova o id indexado do elemento.'
		);

	return { 'field': field };

};

const getId = function(node)
{
	return [node.id, node.className, node.name].find(id => id && id.match(REGEX));
};

const _appendRows = function(table, row_count, do_not_init)
{

	let rows = document.querySelectorAll(table.selector);
	let first_row = rows[0];
	let last_row = rows[rows.length - 1];

	for (let i = 0; i < row_count; i++)
	{
		let cloned_row = first_row.cloneNode(true);		// true: clone all descendants too
		incrementColumnsIndices(table, cloned_row);
		last_row = last_row.parentNode.insertBefore(cloned_row, last_row.nextSibling);	// Update last_row for the next loop iteraction
		insertFields(table, cloned_row, do_not_init);
	}

};

const incrementColumnsIndices = function(table, cloned_row)
{
	table.columns.forEach(column =>		// { field }
	{
		incrementColumnIndices(table, cloned_row, column);
	});
};

const incrementColumnIndices = function(table, cloned_row, column)
{

	let new_node = getColumnNode(cloned_row, column);
	let new_index = addToIndex(getLastRowIndex(table, column), 1);

	setIndex(new_node, new_index);

	if (new_node.nodeName == 'SELECT')		// Prevent a cloned SELECT from briefly showing a selected OPTION on screen
		new_node.selectedIndex = -1;

};

const getColumnNode = function(row, column)
{
	return findElementIn(row, column.field.selector.match(REGEX)[1]);	// "#form #field-0" --> "field"
};

const findElementIn = function(node, selector)
{
	return node.querySelector(`[id|="${selector}"],[class|="${selector}"],[name|="${selector}"],${selector}`);		// Must match "field" and "field-0" but not "fields"
};

const addToIndex = function(index_str, number)		// String required to allow preserving the original index length
{
	if (!index_str)									// Happens when non-indexed datalists are mixed with table rows
		return;
	let new_index = String(Number(index_str) + number);
	let length = Math.max(new_index.length, index_str.length);
	return ('0000' + new_index).slice(-length);
};

const getLastRowIndex = function(table, column)
{
	let last_row = Array.from(document.querySelectorAll(table.selector)).pop();
	let node = getColumnNode(last_row, column);
	return getIndex(node);
};

const getIndex = function(node)
{
	return getId(node)?.match(REGEX)?.at(-1);		// Rows may point to non-indexed datalists
};

const setIndex = function(node, index)
{
	['id', 'class', 'name', 'list'].forEach(attr_name =>
	{
		let attr_value = node.getAttribute(attr_name);
		let is_attr_indexed = Boolean(attr_value?.match(REGEX));
		if (is_attr_indexed)
			node.setAttribute(attr_name, replaceIndex(attr_value, index));
		if (is_attr_indexed && attr_name == 'list')
			node.parentNode.querySelector(`#${attr_value}`)?.setAttribute('id', replaceIndex(attr_value, index));	// Fix the <datalist> id, if present
	});
};

const replaceIndex = function(string, index)
{
	return string.replace(REGEX, '$1$2' + index);
};

const insertFields = function(table, cloned_row, do_not_init)
{
	table.columns.forEach(column =>		// { field }
	{
		insertField(table, cloned_row, column, do_not_init);
	});
};

const insertField = function(table, cloned_row, column, do_not_init)
{

	let new_index = getIndex(getColumnNode(cloned_row, column));
	let new_selector = replaceIndex(column.field.selector, new_index); 
	let new_field = column.field.create({ selector: new_selector });

	table.form.insertOrUpdateField(new_field);

	if (!do_not_init)
	{
		new_field.eraseValue();
		new_field.setErrorState(false);
		new_field.captureEvents();
		new_field.refresh();
	}

};

const _removeRows = function(table, indices_to_remove)
{

	let rows = document.querySelectorAll(table.selector);

	let is_removing_all_rows = indices_to_remove.length == rows.length;

	if (is_removing_all_rows)
		indices_to_remove.pop();		// Always leave at least one row in the table

	shiftRowsUp(table, rows, indices_to_remove);		// Move values from rows below over rows-to-be-deleted, "compacting" the list

	removeRowsAndFields(table, rows, indices_to_remove);	// Remove excess rows listed in indices_to_remove after previous operation

};

const shiftRowsUp = function(table, rows, indices_to_remove)		// indices_to_remove contains a modified list of indices after this operation
{
	while (indices_to_remove.length)
	{
		
		indices_to_remove.sort((a, b) => (a - b));		// Sort in ascending order; List keeps changing and requires re-sorting;

		let to_index = indices_to_remove[0];
		let from_index = findNextIndexNotRemoved(indices_to_remove, to_index, rows.length);
		let no_more_rows_to_move = from_index == rows.length;

		if (no_more_rows_to_move)
			break;
	
		moveColumns(table, from_index, to_index);
		
		indices_to_remove.shift();				// Remove 'to' index from the list (refers to a regular row now)
		indices_to_remove.push(from_index);		// Include 'from' index in the list (refers to a deleted row now)
		
	}
};

const findNextIndexNotRemoved = function(indices, initial_index, row_count)
{
	let current_index = initial_index, is_last_row, is_index_in_removed_list;
	do
	{
		current_index += 1;
		is_last_row = current_index == row_count;
		is_index_in_removed_list = indices.indexOf(current_index) != -1;		// -1: not found
	}
	while (!is_last_row && is_index_in_removed_list);
	return current_index;
};

const moveColumns = function(table, from_index, to_index)
{
	table.columns.forEach(column =>
	{
		moveColumn(table, column, from_index, to_index);
	});
};

const moveColumn = function(table, column, from_index, to_index)
{

	let from_field_sel = replaceIndex(column.field.selector, from_index);
	let to_field_sel = replaceIndex(column.field.selector, to_index);

	let from_field = table.form.getFieldBySelector(from_field_sel);
	let to_field = table.form.getFieldBySelector(to_field_sel);

	let value = from_field.getValue();

	if (value)
		to_field.setValue(value);
	else
		to_field.eraseValue();

	to_field.refresh();

};

const removeRowsAndFields = function(table, rows, indices_to_remove)
{
	indices_to_remove.forEach(index => 
	{ 
		table.columns.forEach(column =>
		{
			let selector = replaceIndex(column.field.selector, index);
			let field = table.form.getFieldBySelector(selector);
			table.form.deleteField(field.getId());
		});
		rows[index]?.parentNode.removeChild(rows[index]);		// Must be removed only AFTER the fields have been removed from the form
	});
};

const _moveRow = function(table, from_index, count)
{
	let rows = document.querySelectorAll(table.selector);
	let to_index = from_index + count;
	if (to_index < 0 || to_index >= rows.length)
		return false;
	let is_moving_down = count > 0;
	let from_node = rows[from_index];
	let to_node = is_moving_down ? rows[to_index].nextSibling : rows[to_index];
	rows[0].parentNode.insertBefore(from_node, to_node);
	renameColumnsAndFields(table, from_index, to_index, count);
	return true;
};

const renameColumnsAndFields = function(table, from_index, to_index, count)
{
	let rows = document.querySelectorAll(table.selector);
	let first_index = from_index < to_index ? from_index : to_index;
	let last_index = from_index < to_index ? to_index : from_index;
	for (let i = first_index; i <= last_index; i++)
	{
		table.columns.forEach(column =>
		{
			let node = getColumnNode(rows[i], column);
			let old_index = getIndex(node);
			let new_index = addToIndex(old_index, i == to_index ? count : Math.sign(count) * -1);
			let old_selector = replaceIndex(column.field.selector, old_index); 
			let new_selector = replaceIndex(column.field.selector, new_index); 
			let field = table.form.getFieldBySelector(old_selector); 
			let old_id = field.getId();
			setIndex(node, new_index);
			field.selector = new_selector;
			let new_id = field.getId();
			table.form.replaceFieldId(old_id, new_id + '_tmp');				// Create a temp id to avoid collisions (field-3 -> field-1 and field-1 exists)
		});
	}
	renameAndUpdate(table, rows, first_index, last_index);
};

const renameAndUpdate = function(table, rows, first_index, last_index)
{
	for (let i = first_index; i <= last_index; i++)
	{
		table.columns.forEach(column =>
		{
			let index = getIndex(getColumnNode(rows[i], column));
			let field = table.form.getFieldBySelector(replaceIndex(column.field.selector, index));
			let id = field.getId();
			table.form.replaceFieldId(id + '_tmp', id);
			let node = document.querySelector(field.selector);
			//field.setValue(node.type.match(/checkbox/i) ? node.checked : node.value);
			node.dispatchEvent(new Event('change'));
			node.dispatchEvent(new Event('blur'));
		});
	}
};

const table = {

	form: null,
	selector: null,
	columns: null,

	create(form, row_selector)
	{
		let table = Object.create(this);
		table.selector = row_selector;
		table.form = form;
		table.columns = getColumns(form, row_selector);
		return table;
	},

	appendRows(count, do_not_init)
	{
		_appendRows(this, count, do_not_init);
	},

	removeRows(indices)
	{
		_removeRows(this, indices);
	},

	moveRow(index, count)	// count can be positive (move down) or negative (move up)
	{
		return _moveRow(this, index, count);
	}

};

export { table as default, replaceIndex, REGEX };

